import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { PhoneCall, ArrowUpRight } from "lucide-react";

const links = [
  { label: "Home", path: "/", testid: "nav-link-home" },
  { label: "Services", path: "/services", testid: "nav-link-services" },
  { label: "Offerings", path: "/offerings", testid: "nav-link-offerings" },
  { label: "Calculator", path: "/calculator", testid: "nav-link-calculator" },
  { label: "FAQ", path: "/faq", testid: "nav-link-faq" },
  { label: "Contact", path: "/contact", testid: "nav-link-contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const onDarkHero = location.pathname === "/" && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        onDarkHero
          ? "bg-transparent"
          : "bg-white/85 backdrop-blur-xl border-b border-brand/10 shadow-[0_4px_30px_rgba(3,59,43,0.06)]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-2 shrink-0">
          <img
            src={onDarkHero ? "/logo-light.png" : "/logo.png"}
            alt="SolarSoch"
            className="h-9 md:h-11 w-auto transition-all"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-1" data-testid="desktop-nav">
          {links.map((l) => (
            <NavLink
              key={l.path}
              to={l.path}
              data-testid={l.testid}
              className={({ isActive }) =>
                `px-4 py-2 rounded-full text-sm font-semibold tracking-wide transition-colors duration-300 ${
                  isActive
                    ? onDarkHero
                      ? "bg-gold text-brand-deep"
                      : "bg-brand text-white"
                    : onDarkHero
                      ? "text-white/80 hover:text-gold"
                      : "text-ink/70 hover:text-brand"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="tel:+919619613720"
            data-testid="header-call-button"
            className={`flex items-center gap-2 rounded-full px-3.5 py-2 text-sm font-bold transition-transform hover:scale-105 ${
              onDarkHero ? "bg-gold text-brand-deep" : "bg-brand text-white"
            }`}
          >
            <PhoneCall size={15} strokeWidth={2.5} />
            <span className="hidden sm:inline">+91 96196 13720</span>
            <span className="sm:hidden">Call</span>
          </a>
          <Link
            to="/contact"
            data-testid="header-survey-cta"
            className={`hidden lg:flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-bold border transition-colors ${
              onDarkHero
                ? "border-white/30 text-white hover:border-gold hover:text-gold"
                : "border-brand/25 text-brand hover:bg-brand hover:text-white"
            }`}
          >
            Free Survey <ArrowUpRight size={15} />
          </Link>
        </div>
      </div>
    </header>
  );
}
